import React from 'react';
import * as ROUTES from 'constants/routes';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

const PrivateRoute = ({ component: Component, isLogged, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (isLogged ? <Component {...props} /> : <Redirect to={ROUTES.SIGNIN} />)}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.func.isRequired,
  isLogged: PropTypes.bool.isRequired
};

export default PrivateRoute;
